import {Choice} from "Vendor/Components/Form/Type/ChoiceType";

const MatchedByFieldChoice: Choice[] = [
    {
        i18nKey: 'app.enum.collection.import.column.matched_by_field.identifier',
        value: 'identifier'
    },
    {
        i18nKey: 'app.enum.collection.import.column.matched_by_field.name',
        value: 'name'
    },
    {
        i18nKey: 'app.enum.collection.import.column.matched_by_field.property',
        value: 'property'
    },
]

export default MatchedByFieldChoice
